<div class="shape-selector-component flex-row">
  <div>{{ key }}</div>
  <div>{{  selectedShape?.label }}</div>
  <nw-option-select
    *ngIf="shapes"
    [data]="shapes"
    (itemSelected)="shapeChanged($event)"
  >
    <ng-template let-value>
      <div class="flex-row">
        <div style="white-space: nowrap;">{{ value.label }}</div>
      </div>
    </ng-template>
  </nw-option-select>

  <!-- <select [value]="selectedShape">
    <option></option>
    <option *ngFor="let shape of shapes" [value]="shape.IRI"> {{ shape.label }}</option>
  </select> -->
</div>
